// extracted by mini-css-extract-plugin
export default {"Container":"VideoImage_Container__dkCEr","DeskWrap":"VideoImage_DeskWrap__1cgJR","ImgDesk":"VideoImage_ImgDesk__3HNxh","ToolBox":"VideoImage_ToolBox__auloh"};